import CryptoJS from 'crypto-js';

const cryptoJS = {

    key: CryptoJS.enc.Utf8.parse(process.env.REACT_APP_AES_KEY as string),
    iv: CryptoJS.enc.Utf8.parse(process.env.REACT_APP_AES_VAR as string),

    // Funcion para encriptar
    encrypt(message: string) {
        const encrypted = CryptoJS.AES.encrypt(message, this.key, {
            iv: this.iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        return encrypted.toString();
    },

    // Funcion para desencriptar
    decrypt(ciphertext: string) {
        const decrypted = CryptoJS.AES.decrypt(ciphertext, this.key, {
            iv: this.iv,
            mode: CryptoJS.mode.CBC,
            padding: CryptoJS.pad.Pkcs7
        });
        return decrypted.toString(CryptoJS.enc.Utf8);
    },

};

export default cryptoJS;
  